(() => {
  class FeaturedCollectionFaceting extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sortReady === 'true') return;
      this.dataset.sortReady = 'true';

      this.sortValue = 'manual';
      this.productLists = Array.from(this.querySelectorAll('[data-featured-product-list]'));
      this.originalOrders = this.productLists.map((list) => Array.from(list.querySelectorAll('product-card')));
      this.sortLabel = this.querySelector('[data-featured-sort-label]');
      this.sortListbox = this.querySelector('[data-featured-sort-listbox]');

      const trigger = this.querySelector('[data-featured-sort-trigger]');
      const popoverId = trigger?.getAttribute('aria-controls');
      this.sortPopover = popoverId ? document.getElementById(popoverId) : null;

      if (!this.sortListbox) return;

      this.sortListbox.addEventListener('click', (event) => {
        const option = event.target.closest('[data-sort-value]');
        if (!option) return;

        event.preventDefault();
        this.sortValue = option.getAttribute('data-sort-value');

        this.sortListbox.querySelectorAll('[data-sort-value]').forEach((item) => {
          item.setAttribute('aria-selected', item === option ? 'true' : 'false');
        });

        if (this.sortLabel) {
          this.sortLabel.textContent = option.textContent.trim();
        }

        this.apply();
        this.closePopover();
      });
    }

    closePopover() {
      if (!this.sortPopover) return;

      if (typeof this.sortPopover.hide === 'function') {
        this.sortPopover.hide();
        return;
      }

      this.sortPopover.removeAttribute('open');
      this.sortPopover.dispatchEvent(new Event('close', { bubbles: true }));
    }

    apply() {
      this.productLists.forEach((list, index) => {
        const cards = this.originalOrders[index].slice();

        if (this.sortValue === 'price-ascending') {
          cards.sort((a, b) => Number(a.dataset.price || 0) - Number(b.dataset.price || 0));
        } else if (this.sortValue === 'price-descending') {
          cards.sort((a, b) => Number(b.dataset.price || 0) - Number(a.dataset.price || 0));
        }

        cards.forEach((card) => list.appendChild(card));
      });
    }
  }

  if (!window.customElements.get('featured-collection-faceting')) {
    window.customElements.define('featured-collection-faceting', FeaturedCollectionFaceting);
  }

  document.querySelectorAll('featured-collection-faceting').forEach((el) => {
    if (el.dataset.sortReady !== 'true') {
      FeaturedCollectionFaceting.prototype.connectedCallback.call(el);
    }
  });
})();
